module.exports = __webpack_public_path__ + "img/rightImg.f23dabb6.png";